const map = {
  'Modules.Login': () => import('@/components/modules/login/index.vue'),
  'Modules.TwoBall': () => import('@/components/modules/twoColorBall/index.vue'),
  'RouteView.RouteTwo': () => import('@/components/routeView/two/index.vue')
}

export function resolveByString(s) {
  const fn = map[s]
  return fn ? fn : () => import('@/components/modules/404/notFindComponent.vue')
}
